// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodNutrientTypeId } from './FoodNutrientType';
import { invProductId } from './InvProduct';
import { z } from 'zod';
export const foodIngredientNutrientId = (z.number());
export const foodIngredientNutrient = z.object({
    id: foodIngredientNutrientId,
    nutrient_type_id: foodNutrientTypeId,
    value: z.number(),
    unit: z.string(),
    created_at: z.date().nullable(),
    product_id: invProductId,
    estimate_note: z.string().nullable(),
});
export const foodIngredientNutrientInitializer = z.object({
    id: foodIngredientNutrientId.optional(),
    nutrient_type_id: foodNutrientTypeId,
    value: z.number(),
    unit: z.string(),
    created_at: z.date().optional().nullable(),
    product_id: invProductId,
    estimate_note: z.string().optional().nullable(),
});
export const foodIngredientNutrientMutator = z.object({
    id: foodIngredientNutrientId.optional(),
    nutrient_type_id: foodNutrientTypeId.optional(),
    value: z.number().optional(),
    unit: z.string().optional(),
    created_at: z.date().optional().nullable(),
    product_id: invProductId.optional(),
    estimate_note: z.string().optional().nullable(),
});
//# sourceMappingURL=FoodIngredientNutrient.js.map